import React from 'react';
import { appConfig } from '../services';

const Logo = () => {
    const { logoSrc } = appConfig.site;

    return (
        <div className="Logo">
            <img
                className='Logo__img'
                src={logoSrc}
                alt="logo"
            />
        </div>  
    )
};

export default Logo;

